import {
    HttpResponse,
    WalletModel,
    QueryModel,
    RequestParams,
    WalletModelIEnumerableApiResultSuccess,
    WalletModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    FullRequestParams,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery} from '@/libs/core/crud/crud-query';
import {CrudService, CrudListResponse, CrudResponse} from '@/libs/core/crud/crud-service';

export class WalletsDataService implements CrudService<WalletModel, WalletModel> {
    
    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        throw new Error("Method not implemented.");
    }
    
    getGrouped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        throw new Error("Method not implemented.");
    }
    
    getAll(query: CrudDataQuery<WalletModel>): Promise<CrudListResponse<WalletModel>> {
        return ApiService.api.getWalletBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<WalletModel>> {
        return ApiService.api.getWalletById(id, params);
    }

    create(item: WalletModel, params?: RequestParams): Promise<CrudResponse<WalletModel>> {
        return ApiService.api.insertWallet(item, params);
    }

    update(item: WalletModel, params?: RequestParams): Promise<WalletModel> {
        return ApiService.api.updateWallet(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<WalletModel> {
        return ApiService.api.patchWallet(id, patches).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<WalletModel>): Promise<CrudListResponse<WalletModel>> {
        return ApiService.api.deleteWallet(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<WalletModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw "NotImplemented";
    }

}
